// web が apps/api を叩く時の base URL。
// dev: 直接 http://localhost:8787 (wrangler dev)。
// prod: 同一 origin か Pages の env で上書き想定。

export const API_BASE_URL: string =
  import.meta.env.VITE_API_BASE_URL ?? 'http://localhost:8787';
